export const LEVEL_MARGIN_PX = 32;
export const LEVEL_MARGIN = `${LEVEL_MARGIN_PX / 10}rem`;
export const TREE_GUIDE_OFFSET = "1.4rem";

// Room for the cell's own content next to the indentation. The first column's minimum width is built
// from this, so the indentation itself never has to give way
export const TREE_RESERVED_CONTENT_WIDTH_PX = 40;

// `--semantic-spacing-x-large`, the cell's horizontal padding. The reserve above is content width,
// so a column width has to account for the padding on both sides on top of it.
export const CELL_PADDING_PX = 16;
export const SPACE_TREE_LIST_ROOT_SPACE_USERFLOW_ID = "spaces-list-root-space";
